/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Offers_TitleInputs */

const en_directory_submit_offers_title = /** @type {(inputs: Directory_Submit_Offers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing & offers`)
};

const zh_directory_submit_offers_title = /** @type {(inputs: Directory_Submit_Offers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价与优惠`)
};

/**
* | output |
* | --- |
* | "Pricing & offers" |
*
* @param {Directory_Submit_Offers_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_offers_title = /** @type {((inputs?: Directory_Submit_Offers_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Offers_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_offers_title(inputs)
	return zh_directory_submit_offers_title(inputs)
});
export { directory_submit_offers_title as "directory.submit.offers_title" }